
import { AppCadastro } from './app-cadastro.js';
import { PropertyResults, PropertyResultsManager } from './PropertyResults.js';
import CatastroClient from './catastro-browser.js';

export function CadastroForm() {
    return `
        <section class="section bg-transparent py-8">
            <div class="container max-w-2xl mx-auto">
                <div class="text-center mb-4">
                </div>
                <div class="bg-white/90 backdrop-blur-sm rounded-lg shadow-lg border border-white/30 p-4">
                    <!-- Status indicator -->
                    <div class="mb-6 text-center">
                        <h2 class="text-3xl font-bold text-gray-900 mb-4">
                            Start <span class="italic text-green-600">your free comparison now!</span>
                        </h2>
                        <p class="text-gray-600">Compare and request in one minute</p>
                        <!-- Service Type Section -->
                        <div class="mt-1">
                            <div class="flex space-x-2">
                                <button type="button" 
                                        id="service-energielabel" 
                                        class="flex-1 px-6 py-3 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 transition-colors"
                                        data-service="energielabel">
                                    Energy certificate
                                </button>
                                <button type="button" 
                                        id="service-label-advies" 
                                        class="flex-1 px-6 py-3 bg-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-400 hover:text-white transition-colors"
                                        data-service="label-advies">
                                    Improvement report
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- Tab Navigation -->
                    <div class="mb-1">
                        <ul class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
                            <li class="Home">
                                <a href="/home" aria-current="page" class="inline-block p-4 text-blue-600 bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500">Address</a>
                            </li>
                            <li class="Partner">
                                <a href="#" class="inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300">Registry code</a>
                            </li>
                            <li class="Postal">
                                <a href="/" class="inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300">Postal code</a>
                            </li>
                        </ul>
                    </div>
                    <!-- Tab Content -->
                    <div id="adres-content" class="tab-content space-y-4">
                        <div>
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <!-- Provincie -->
                                <div class="relative">
                                    <label class="block text-xs font-medium text-gray-700 mb-1">
                                        Province <span id="provinces-count" class="text-xs text-gray-500">(loading...)</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        id="province-input" 
                                        maxlength="3"
                                        placeholder="Type 3 characters and select..." 
                                        class="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed text-xs placeholder:text-xs" 
                                        disabled
                                        autocomplete="off"
                                    >
                                    <div id="province-dropdown" class="absolute z-20 w-full bg-white border border-gray-300 rounded-lg shadow-lg mt-1 max-h-40 overflow-y-auto hidden">
                                    </div>
                                </div>
                                <!-- Gemeente -->
                                <div class="relative">
                                    <label class="block text-xs font-medium text-gray-700 mb-1">
                                        Municipality <span id="municipalities-count" class="text-xs text-gray-500">(select)</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        id="municipality-input" 
                                        maxlength="3"
                                        placeholder="Type 3 characters and select..." 
                                        class="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed text-xs placeholder:text-xs" 
                                        disabled
                                        autocomplete="off"
                                    >
                                    <div id="municipality-dropdown" class="absolute z-20 w-full bg-white border border-gray-300 rounded-lg shadow-lg mt-1 max-h-40 overflow-y-auto hidden">
                                    </div>
                                </div>
                                <!-- Straat -->
                                <div class="relative">
                                    <label class="block text-xs font-medium text-gray-700 mb-1">
                                        Street <span id="streets-count" class="text-xs text-gray-500">(select)</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        id="street-input" 
                                        maxlength="3"
                                        placeholder="Type 3 characters and select..." 
                                        class="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed text-xs placeholder:text-xs" 
                                        disabled
                                        autocomplete="off"
                                    >
                                    <div id="street-dropdown" class="absolute z-20 w-full bg-white border border-gray-300 rounded-lg shadow-lg mt-1 max-h-40 overflow-y-auto hidden">
                                    </div>
                                </div>
                                <!-- Huisnummer -->
                                <div>
                                    <label class="block text-xs font-medium text-gray-700 mb-1">Number</label>
                                    <input 
                                        type="text" 
                                        id="numero" 
                                        placeholder="e.g. 1" 
                                        class="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed text-xs placeholder:text-xs" 
                                        disabled
                                    >
                                </div>
                            </div>
                            <!-- Type gebouw -->
                            <div>
                                <label class="block text-xs font-medium text-gray-700 mb-1 mt-4">
                                    What type of property?
                                    <span class="text-gray-400">?</span>
                                </label>
                                <div class="relative">
                                    <select id="building-type-card"
                                            class="w-full p-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white text-xs">
            <option value="">Select property</option>
            <option>Apartment</option>
            <option>House, villa, detached</option>
            <option>Commercial space</option>
            <option>Individual office</option>
            <option>Building</option>
                                    </select>
                                    <div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                                        <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <!-- Search Button -->
                            <div class="mt-4 text-center">
                                <button id="search-btn" class="bg-purple-800 hover:bg-purple-600 text-white py-4 px-8 rounded-lg font-semibold text-xl transition-colors disabled:bg-purple-500 disabled:cursor-not-allowed" disabled>
                                    Find the best advisor
                                </button>
                            </div>
                            <!-- Results Container - Gebruik PropertyResults component -->
                            <div class="mt-4">
                                ${PropertyResults()}
                            </div>
                        </div>
                    </div>
                    <!-- Registry Code Section -->
                    <div id="registratiecode-content" class="tab-content hidden">
                        <section class="search-section codigo-registral">
                            <h2 class="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                                📋 Unique Registry Code
                            </h2>
                            <div class="form-grid">
                                <div class="form-group">
                                     <label for="codigo-registral" class="block text-xs font-medium text-gray-700 mb-2">Unique registry code:</label>
                                     <input type="text" 
                                         id="codigo-registral" 
                                         placeholder="e.g. 2749704YJ0624N0001DI"
                                         class="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-xs placeholder:text-xs">
                                </div>
                            </div>
                                                        <!-- Type gebouw -->
                            <div>
                                <label class="block text-xs font-medium text-gray-700 mb-1 mt-4">
                                    What type of property?
                                    <span class="text-gray-400">?</span>
                                </label>
                                <div class="relative">
                                    <select id="building-type-registral"
                                            class="w-full p-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white text-xs">
            <option value="">Select property</option>
            <option>Apartment</option>
            <option>House, villa, detached</option>
            <option>Commercial space</option>
            <option>Individual office</option>
            <option>Building</option>
                                    </select>
                                    <div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                                        <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-8 text-center">
                                <button id="codigo-registral-btn" class="bg-green-600 hover:bg-green-700 text-white py-4 px-8 rounded-lg font-semibold text-xs transition-colors disabled:bg-green-400 disabled:cursor-not-allowed" disabled>
                                    Search Registry Code
                                </button>
                            </div>
                            <!-- Registration Code Results Container -->
                            <div class="mt-8" id="codigo-registral-results">
                                ${PropertyResults()}
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    `;
}

// Initialize the cadastro form functionality when this component is loaded
export function initializeCadastroForm() {
  resetSearchState();

  setupTabSwitching();
  setupServiceTypeSwitching();
  setupRegistrationCodeForm();
  checkAndFillUrlParameters();

  waitForDireccionDom(() => {
    const AppClass = AppCadastro();
    const appInstance = new AppClass();
    window.cadastroAppInstance = appInstance;
  });

  setTimeout(() => {
    const buildingTypeCard = document.getElementById('building-type-card');
    const searchBtn = document.getElementById('search-btn');

    if (buildingTypeCard && searchBtn) {
      const updateDireccionButton = () => {
        const isValid =
          buildingTypeCard.value &&
          buildingTypeCard.value !== '' &&
          buildingTypeCard.selectedIndex > 0;

        searchBtn.disabled = !isValid;
        searchBtn.classList.toggle('disabled:cursor-not-allowed', !isValid);
      };

      updateDireccionButton();
      buildingTypeCard.addEventListener('change', updateDireccionButton);
    }

    updateCodigoRegistralButtonState();
  }, 0);
}








// ✅ Check URL parameters and auto-fill código registral if present
function checkAndFillUrlParameters() {
    setTimeout(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tipo = urlParams.get('tipo');
        const codigo = urlParams.get('codigo');
        
        // If tipo=codigo and codigo is provided, switch to registratiecode tab and fill the code
        if (tipo === 'codigo' && codigo) {
            console.log('📋 Auto-filling código registral from URL:', codigo);
            
            // Switch to registratiecode tab
            window.switchTab('dashboard');
            
            // Fill the código registral input
            setTimeout(() => {
                const codigoInput = document.getElementById('codigo-registral');
                if (codigoInput) {
                    codigoInput.value = codigo;
                    
                    // Trigger validation
                    const codigoBtn = document.getElementById('codigo-registral-btn');
                    validateRegistrationCode(codigo);
updateCodigoRegistralButtonState();

                    if (codigoInput) {
  codigoInput.value = codigo;
  validateRegistrationCode(codigo);
  updateCodigoRegistralButtonState();
  codigoInput.focus();
}
                    // Auto-focus on the input for user visibility
                    codigoInput.focus();
                    
                    console.log('✅ Código registral auto-filled and validated');
                } else {
                    console.warn('⚠️ Código registral input not found');
                }
            }, 200); // Small delay to ensure tab switch is complete
        }
    }, 150); // Delay to ensure all DOM elements are ready
}

// ✅ Setup tab switching functionality
function setupTabSwitching() {
    // Initialize tab functionality after DOM is loaded
    setTimeout(() => {
        const profileTab = document.querySelector('.Home a');
        const dashboardTab = document.querySelector('.Partner a');
        
        if (profileTab && dashboardTab) {
            // Add click handlers for tabs
            profileTab.addEventListener('click', function(e) {
                e.preventDefault();
                switchTab('profile');
            });
            
            dashboardTab.addEventListener('click', function(e) {
                e.preventDefault();
                switchTab('dashboard');
            });
        }
    }, 100);
    
    // Define switchTab function on window object
    window.switchTab = function (tabType) {
        console.log("switchTab called with:", tabType);
        
        const profileTab = document.querySelector('.Home a');
        const dashboardTab = document.querySelector('.Partner a');

        console.log("Elements found:", { profileTab, dashboardTab });

        if (!profileTab || !dashboardTab) {
            console.warn("Tab elementen niet gevonden");
            return;
        }

        // Get tab content elements
        const adresContent = document.getElementById('adres-content');
        const registratiecodeContent = document.getElementById('registratiecode-content');

        if (tabType === "profile") {
            // Activate Adres tab
            profileTab.className = "inline-block p-4 text-blue-600 bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500";
            dashboardTab.className = "inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300";
            
            // Show/hide content
            if (adresContent) adresContent.classList.remove('hidden');
            if (registratiecodeContent) registratiecodeContent.classList.add('hidden');
            
            console.log("Adres tab activated");
        } else if (tabType === "dashboard") {
            // Activate Registratiecode tab
            profileTab.className = "inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300";
            dashboardTab.className = "inline-block p-4 text-blue-600 bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500";
            
            // Show/hide content
            if (adresContent) adresContent.classList.add('hidden');
            if (registratiecodeContent) registratiecodeContent.classList.remove('hidden');
            
            console.log("Registratiecode tab activated");
        }
    };
}

// ✅ Setup service type switching functionality
function setupServiceTypeSwitching() {
    setTimeout(() => {
        const energielabelBtn = document.getElementById('service-energielabel');
        const labelAdviesBtn = document.getElementById('service-label-advies');
        
        if (energielabelBtn && labelAdviesBtn) {
            // Set initial state (Certificado selected by default)
            let selectedServiceType = 'energielabel';
            
            // Add click handlers
            energielabelBtn.addEventListener('click', function() {
                selectServiceType('energielabel', energielabelBtn, labelAdviesBtn);
                selectedServiceType = 'energielabel';
            });
            
            labelAdviesBtn.addEventListener('click', function() {
                selectServiceType('label-advies', labelAdviesBtn, energielabelBtn);
                selectedServiceType = 'label-advies';
            });
            
            // Store the getter and setter functions on window object for access from other parts
            window.getSelectedServiceType = function() {
                return selectedServiceType;
            };
            
            // ✅ Setter functie voor herstellen van opgeslagen waarden
            window.setSelectedServiceType = function(newServiceType) {
                selectedServiceType = newServiceType;
                if (newServiceType === 'energielabel') {
                    selectServiceType('energielabel', energielabelBtn, labelAdviesBtn);
                } else {
                    selectServiceType('label-advies', labelAdviesBtn, energielabelBtn);
                }
            };
        }
    }, 100);
}

// Helper function to handle service type selection
function selectServiceType(serviceType, activeButton, inactiveButton) {
    // Update active button styling (green)
    activeButton.className = "flex-1 px-6 py-3 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 transition-colors";
    
    // Update inactive button styling (gray)
    inactiveButton.className = "flex-1 px-6 py-3 bg-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-400 hover:text-white transition-colors";
    
    console.log(`Service type selected: ${serviceType}`);
}

function setupRegistrationCodeForm() {
  setTimeout(() => {
    const codigoInput = document.getElementById('codigo-registral');
    const codigoBtn = document.getElementById('codigo-registral-btn');
    const buildingTypeSelect = document.getElementById('building-type-registral');

    if (!codigoInput || !codigoBtn) return;

    codigoInput.addEventListener('input', () => {
      validateRegistrationCode(codigoInput.value);
      updateCodigoRegistralButtonState();
    });

    if (buildingTypeSelect) {
      buildingTypeSelect.addEventListener('change', () => {
        updateCodigoRegistralButtonState();
      });
    }

    codigoBtn.addEventListener('click', () => {
      if (!codigoBtn.disabled) {
        handleRegistrationCodeSearch(codigoInput.value);
      }
    });

    codigoInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && !codigoBtn.disabled) {
        handleRegistrationCodeSearch(codigoInput.value);
      }
    });
  }, 100);
}




function updateCodigoRegistralButtonState() {
  const codigoInput = document.getElementById('codigo-registral');
  const buildingTypeSelect = document.getElementById('building-type-registral');
  const codigoBtn = document.getElementById('codigo-registral-btn');

  if (!codigoInput || !buildingTypeSelect || !codigoBtn) return;

  const isCodigoValid = codigoInput.value.trim().length === 20;
  const isBuildingTypeSelected =
    buildingTypeSelect.value && buildingTypeSelect.value !== '';

  const isEnabled = isCodigoValid && isBuildingTypeSelected;

  codigoBtn.disabled = !isEnabled;

  codigoBtn.className = isEnabled
    ? "bg-green-600 hover:bg-green-700 text-white py-4 px-8 rounded-lg font-semibold text-xs transition-colors"
    : "bg-green-600 text-white py-4 px-8 rounded-lg font-semibold text-xs transition-colors disabled:bg-green-400 disabled:cursor-not-allowed";
}


// Validate registration code (20 characters)
function validateRegistrationCode(code) {
  const codigoInput = document.getElementById('codigo-registral');
  if (!codigoInput) return;

  if (code.length > 0 && code.length !== 20) {
    codigoInput.className =
      "w-full p-4 border-2 border-red-300 rounded-lg focus:ring-2 focus:ring-red-500";
  } else if (code.length === 20) {
    codigoInput.className =
      "w-full p-4 border-2 border-green-300 rounded-lg focus:ring-2 focus:ring-green-500";
  } else {
    codigoInput.className =
      "w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500";
  }
}

    

    


// Handle registration code search
async function handleRegistrationCodeSearch(refCat) {
    if (!refCat || refCat.trim().length !== 20) {
        console.error('Invalid registration code');
        return;
    }
    
    const button = document.getElementById('codigo-registral-btn');
    const resultsContainer = document.getElementById('codigo-registral-results');
    
    try {
        // Show loading state
        if (button) {
            button.disabled = true;
            button.textContent = 'Bezig met zoeken...';
        }
        
        // Make API call
        const data = await getCodigoRegistralData(refCat.trim());
        
        if (data) {
            // Store data for compare page FIRST
            sessionStorage.setItem('propertyData', JSON.stringify(data));
            sessionStorage.setItem('searchType', 'registratiecode');
            
            // Get the selected building type from the form
const registralSection = document.getElementById('registratiecode-content');
const buildingTypeSelect =
    registralSection.querySelector('#building-type-registral');

const buildingType = buildingTypeSelect?.value || '';

            
            // Get the selected service type from the form
            const serviceType = window.getSelectedServiceType ? window.getSelectedServiceType() : 'energielabel';
            const serviceTypeDisplay = serviceType === 'energielabel' ? 'Certificado' : 'Informe de mejoras';
            
            // Also store the search data (what the user entered)
            const searchData = {
                codigoRegistral: refCat.trim(),
                searchType: 'registratiecode',
                serviceType: serviceTypeDisplay,
                buildingType: buildingType
            };
            sessionStorage.setItem('propertySearchData', JSON.stringify(searchData));
            
            window.location.href = '/compare/';
            
            // Navigate to compare page after a short delay to allow users to see the results
            setTimeout(() => {
                window.location.href = '/compare/';
            }, 1500); // 1.5 second delay
        }
        
    } catch (error) {
        console.error('Error fetching registration code data:', error);
        
        if (resultsContainer) {
            resultsContainer.innerHTML = `
                <div class="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
                    <h3 class="font-semibold text-red-800">Error</h3>
                    <p class="text-red-700">Er is een fout opgetreden bij het opzoeken van de registratiecode.</p>
                </div>
            `;
        }
        
    } finally {
        // Reset button state
        if (button) {
            button.disabled = false;
            button.textContent = 'Opzoeken Código Registral';
        }
    }
}

// Display property results in Tailwind table format
function displayPropertyResults(data, container) {
    const propertyResult = `
        <div class="mt-8">
            <h3 class="text-xl font-bold text-gray-900 mb-4">Property Result</h3>
            
            <div class="overflow-x-auto">
                <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
                    <thead class="bg-gray-50">
                        <tr>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                Eigenschap
                            </th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                Waarde
                            </th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200">
                        ${generateTableRows(data)}
                    </tbody>
                </table>
            </div>
            
            <div class="mt-6 text-center">
                <button onclick="window.location.href='/compare/'" 
                        class="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors">
                    Go to Comparison
                </button>
            </div>
        </div>
    `;
    
    container.innerHTML = propertyResult;
}

// Generate table rows from property data
function generateTableRows(data) {
    if (!data) return '<tr><td colspan="2" class="px-6 py-4 text-center text-gray-500">No data available</td></tr>';
    
    const rows = [];
    
    // Common property fields to display
    const fieldsToShow = [
        { key: 'RefCat', label: 'Cadastral Reference' },
        { key: 'Direccion', label: 'Address' },
        { key: 'Provincia', label: 'Province' },
        { key: 'Municipio', label: 'Municipality' },
        { key: 'TipoVia', label: 'Street type' },
        { key: 'NombreVia', label: 'Street name' },
        { key: 'Numero', label: 'Number' },
        { key: 'CodigoPostal', label: 'Postal code' },
        { key: 'Uso', label: 'Use' },
        { key: 'Superficie', label: 'Surface' },
        { key: 'SuperficieConstruida', label: 'Built surface' },
        { key: 'AnoConstruction', label: 'Year of construction' },
        { key: 'ClaseVia', label: 'Street class' }
    ];
    
    // Add rows for each field that exists in the data
    fieldsToShow.forEach(field => {
        if (data[field.key] !== undefined && data[field.key] !== null && data[field.key] !== '') {
            rows.push(`
                <tr class="hover:bg-gray-50">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        ${field.label}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        ${data[field.key]}
                    </td>
                </tr>
            `);
        }
    });
    
    // Add any additional fields not in the predefined list
    Object.keys(data).forEach(key => {
        const alreadyShown = fieldsToShow.some(field => field.key === key);
        if (!alreadyShown && data[key] !== undefined && data[key] !== null && data[key] !== '') {
            rows.push(`
                <tr class="hover:bg-gray-50">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        ${key}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        ${data[key]}
                    </td>
                </tr>
            `);
        }
    });
    
    return rows.length > 0 ? rows.join('') : '<tr><td colspan="2" class="px-6 py-4 text-center text-gray-500">No data available</td></tr>';
}

// API call for registration code data using CatastroClient
async function getCodigoRegistralData(refCat) {
    const catastroClient = new CatastroClient();
    return await catastroClient.getCodigoRegistralData(refCat);
}

// Generic API request function (keeping for other uses)
async function makeRequest(endpoint, data) {
    const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });
    
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
}
function waitForDireccionDom(callback) {
  const el = document.getElementById('province-input');
  if (el) {
    callback();
  } else {
    requestAnimationFrame(() => waitForDireccionDom(callback));
  }
}
function resetSearchState() {
  // Compare / search data
  sessionStorage.removeItem('propertyData');
  sessionStorage.removeItem('propertySearchData');
  sessionStorage.removeItem('searchType');

  // Geselecteerde adviseur / booking
  localStorage.removeItem('selectedPartner');
  localStorage.removeItem('selectedAdvisorData');
  localStorage.removeItem('bookingPropertyData');
}